import React from 'react';
import { IIconProps } from '../interfaces';

const PlayAudioTriangleIcon: React.FC<IIconProps> = ({
                                                 color = '#ffffff',       // Default color for the play triangle
                                                 width = '15'             // Default width and height of the icon
                                             }) => (
    <svg width={width} height={(parseInt(width) / 15 * 17)} viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 8.5L0.249999 16.7272L0.25 0.272758L14.5 8.5Z" fill={color}/>
    </svg>

);

export default PlayAudioTriangleIcon;
